
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '../base/Button';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavigation = (sectionId: string) => {
    setIsMenuOpen(false);

    if (location.pathname !== '/') {
      // Se não estiver na home, navega para a home com o hash
      navigate(`/#${sectionId}`);
      // O scroll será tratado por um efeito na Home ou pelo comportamento padrão do browser se configurado
    } else {
      // Se já estiver na home, apenas faz o scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const navigateToBlog = () => {
    setIsMenuOpen(false);
    navigate('/blog');
  };

  const navigateToHome = () => {
    setIsMenuOpen(false);
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div
            className="flex items-center space-x-3 cursor-pointer"
            onClick={navigateToHome}
          >
            <div className="w-16 h-16 flex items-center justify-center">
              <img
                src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/493788cd08f0f0f40d3cddfdb49ed17d.png"
                alt="Dra. Albiana Guerreiro - Advogada Especialista em Direito Previdenciário"
                className="w-18 h-18"
              />
            </div>
            <div>
              <h1 className="text-xl font-bold text-[#214134]">Dra. Albiana Guerreiro</h1>
              <p className="text-sm text-gray-600">Advocacia Previdenciária</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <button
              onClick={navigateToHome}
              className={`text-[#214134] hover:text-[#cc9b3f] font-medium transition-colors cursor-pointer ${location.pathname === '/' ? 'text-[#cc9b3f]' : ''}`}
            >
              Início
            </button>
            <button
              onClick={() => handleNavigation('servicos')}
              className="text-[#214134] hover:text-[#cc9b3f] font-medium transition-colors cursor-pointer"
            >
              Serviços
            </button>
            <button
              onClick={() => handleNavigation('sobre')}
              className="text-[#214134] hover:text-[#cc9b3f] font-medium transition-colors cursor-pointer"
            >
              Sobre
            </button>
            <button
              onClick={navigateToBlog}
              className={`text-[#214134] hover:text-[#cc9b3f] font-medium transition-colors cursor-pointer ${location.pathname.startsWith('/blog') ? 'text-[#cc9b3f]' : ''}`}
            >
              Blog
            </button>
            <button
              onClick={() => handleNavigation('contato')}
              className="text-[#214134] hover:text-[#cc9b3f] font-medium transition-colors cursor-pointer"
            >
              Contato
            </button>
            <Button
              href="https://wa.me/5544988019071?text=Olá! Gostaria de agendar uma consulta sobre direito previdenciário."
              target="_blank"
              size="sm"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Agendar Consulta
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 text-[#214134] hover:text-[#cc9b3f] transition-colors cursor-pointer"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </div>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
            <div className="flex flex-col space-y-4">
              <button
                onClick={navigateToHome}
                className={`text-[#214134] hover:text-[#cc9b3f] font-medium transition-colors text-left cursor-pointer ${location.pathname === '/' ? 'text-[#cc9b3f]' : ''}`}
              >
                Início
              </button>
              <button
                onClick={() => handleNavigation('servicos')}
                className="text-[#214134] hover:text-[#cc9b3f] font-medium transition-colors text-left cursor-pointer"
              >
                Serviços
              </button>
              <button
                onClick={() => handleNavigation('sobre')}
                className="text-[#214134] hover:text-[#cc9b3f] font-medium transition-colors text-left cursor-pointer"
              >
                Sobre
              </button>
              <button
                onClick={navigateToBlog}
                className={`text-[#214134] hover:text-[#cc9b3f] font-medium transition-colors text-left cursor-pointer ${location.pathname.startsWith('/blog') ? 'text-[#cc9b3f]' : ''}`}
              >
                Blog
              </button>
              <button
                onClick={() => handleNavigation('contato')}
                className="text-[#214134] hover:text-[#cc9b3f] font-medium transition-colors text-left cursor-pointer"
              >
                Contato
              </button>
              <Button
                href="https://wa.me/5544988019071?text=Olá! Gostaria de agendar uma consulta sobre direito previdenciário."
                target="_blank"
                size="sm"
                className="w-fit"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                Agendar Consulta
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
